import { render, staticRenderFns } from "./changeBrandModal.vue?vue&type=template&id=80f859c4&scoped=true&"
import script from "./changeBrandModal.vue?vue&type=script&lang=js&"
export * from "./changeBrandModal.vue?vue&type=script&lang=js&"
import style0 from "./changeBrandModal.vue?vue&type=style&index=0&id=80f859c4&scoped=true&lang=css&"
import style1 from "./changeBrandModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f859c4",
  null
  
)

export default component.exports